import { ConsentsObserver, CookieFirstEvent, TrackingConsents } from './types';

type CookieFirstObserver = (event: CookieFirstEvent) => void;

const cookieFirstEventType = 'cf_consent';

const subscribeToCookieFirst = (context: Window, observer: CookieFirstObserver) => {
    context.addEventListener(cookieFirstEventType, observer);
};

const unsubscribeFromCookieFirst = (context: Window, observer: CookieFirstObserver) => {
    context.removeEventListener(cookieFirstEventType, observer);
};

const createConsentsObservable = (context: Window) => {
    const observers: Set<ConsentsObserver> = new Set();
    const cookieFirstObserver: CookieFirstObserver = ({ detail }) => notify(detail);

    const subscribe = (observer: ConsentsObserver) => {
        if (observers.size === 0) {
            subscribeToCookieFirst(context, cookieFirstObserver);
        }
        observers.add(observer);
    };

    const unsubscribe = (observer: ConsentsObserver) => {
        observers.delete(observer);
        if (observers.size === 0) {
            unsubscribeFromCookieFirst(context, cookieFirstObserver);
        }
    };

    const notify = (consents: TrackingConsents) => {
        observers.forEach((observer) => observer(consents));
    };

    return {
        subscribe,
        unsubscribe,
    };
};

export default createConsentsObservable;
